/**
 * Runs `callback` once the browser has painted the next frame: the animation frame callback runs
 * just before the paint, the timeout right after it. Returns a function that cancels the wait.
 */
export function afterNextPaint(callback: () => void): () => void {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  const frameId = requestAnimationFrame(() => {
    timeoutId = setTimeout(callback, 0);
  });

  return () => {
    cancelAnimationFrame(frameId);
    clearTimeout(timeoutId);
  };
}
